export const CLIENT_ID = '3cf9b4d6-850e-4112-a5bd-4d8464e3a5c3';
export const CLIENT_NAME = 'Null_hull';
